const localization: any = {
  en: { 'auto generated': 'Auto\u00A0generated' },
  ja: {'auto generated': '自動生成'},
  fr: {'auto generated': 'Généré\u00A0automatiquement'},
  de: {'auto generated': 'Automatisch\u00A0generiert'},
  es: {'auto generated': 'Generado\u00A0automáticamente'},
  it: {'auto generated': 'Generato\u00A0automaticamente'},
  'pt-BR': {'auto generated': 'Gerado\u00A0automaticamente'},
  'zh-TW': {'auto generated': '自動生成'},
  'zh-CN': {'auto generated': '自动生成'},
  ko: {'auto generated': '자동\u00A0생성됨'}
}
export default localization
